export const convertToTitleCase = (string: string) => {
  let first, rest;

  first = string.substring(0, 1);
  rest = string.substring(1, string.length);

  return `${first.toUpperCase()}${rest.toLowerCase()}`;
};
